import { SubContractor, Document } from "@/services/api";
import { DocumentSchema } from "@/services/api/documents/contracts";
import { z } from "zod";

export const ContractorSchema = z.object({
  AdnocId: z.string(),
  ContractorId: z.number(),
  SubContractorId: z.number(),
  CompanyNameAr: z.string(),
  CompanyNameEn: z.string(),
  PhoneNumber: z.string(),
  MobileNumber: z.string(),
  AdditionalMobileNumber: z.string(),
  Email: z.string(),
  AdditionalEmail: z.string(),
  TradeLicenseExpiryDate: z.string().or(z.date()),
  InsuranceExpiryDate: z.string().or(z.date()).optional(),
  TradeLicenseNumber: z.string().optional(),
  CompanyNo: z.number().optional(),
  ContractorCicpaId: z.number(),
  AdcciMembershipNo: z.string(),
  TradeLicenseDocument: DocumentSchema.optional(),
});

export type Contractor = z.infer<typeof ContractorSchema>;

export type ContractorPayload = Omit<Contractor, "TradeLicenseDocument"> & {
  TradeLicenceDocument: Document;
};

export interface Contractors {
  Contractors: Contractor[];
}

export interface UpdateContractorResponse {
  SubContractorDto: SubContractor[];
}

export interface UpdateContractorPayload {
  AdnocId: string;
  CicpaId: string;
  Email: string;
  TradeLicenseExpiryDate: string | Date;
  TradeLicenseDocument: Document;
}
export type AddSubContractorPayload = {
  AdnocId?: string;
  CompanyNo?: string | number;
  Email?: string;
  CompanyNameAr?: string;
  CompanyNameEn?: string;
  SubContractorNameEn?: string;
  SubContractorNameAr?: string;
  SubContractorId?: string | number;
  CicpaId?: string | number;
  ContractorId?: string | number;
  AdcciMembershipNo?: string | number | null;
  PhoneNumber?: string;
  TradeLicenseExpiryDate: string | Date;
  TradeLicenseDocument: Document;
  TradeLicenseNumber?: string;
  InsuranceExpiryDate?: string;
};
